import { Component, OnInit, Input } from '@angular/core';
import { ProcedureFiveService } from '../../services/procedures/procedure-five.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import {environment} from '../../../environments/environment';
import {FilesService} from '../../services/files.service';

@Component({
  selector: 'ngx-procedure-five',
  templateUrl: './procedure-five.component.html',
  styleUrls: ['./procedure-five.component.scss'],
})
export class ProcedureFiveComponent implements OnInit {
  @Input() stationId: string;
  state = 'Actividades';
  file: any;
  loadingFile = false;
  uploadingFile = false;
  fileIsUploaded = false;
  editFile = false;
  documents = {
    profiles: '',
    designacion: '',
    rh: '',
    structure: '',
  };
  downloading = false;

  constructor(
    private procedureService: ProcedureFiveService,
    private fileService: FilesService,
  ) { }

  ngOnInit() {
    this.getFile();
    this.generateDocument();
  }

  onChangeTab(event) {
    this.state = event.tabTitle;
  }

  loadImage(event) {
    if (!event.target.files.length) return;

    this.file = event.target.files[0];

    const reader = new FileReader();

    reader.readAsDataURL(this.file);

    reader.onload = (e: any) => {
      const imageBase64 = e.target.result;
    };
  }

  async getFile() {
    this.uploadingFile = true;
    const [error, result] = await this.procedureService.getFile(this.stationId, 'designation_technical_representative');
    this.uploadingFile = false;
    if (error) return console.error(error);
    if (result.data !== null) {
      this.fileIsUploaded = true;
    }
  }

  async storeFile() {
    this.uploadingFile = true;
    const data = new FormData();
    data.append('file', this.file);

    // tslint:disable-next-line: max-line-length
    const [error] = await this.procedureService.uploadFile(this.stationId, data, 'designation_technical_representative');
    if (error) {
      this.uploadingFile = false;
      this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
      return error;
    }
    this.alert('Formato cargado con éxito');
    this.getFile();
    this.uploadingFile = false;
  }

  async uploadFile() {
    this.uploadingFile = true;
    const data = new FormData();
    data.append('file', this.file);

    // tslint:disable-next-line: max-line-length
    const [error] = await this.procedureService.updateFile(this.stationId, data, 'designation_technical_representative');
    if (error) {
      this.uploadingFile = false;
      this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
      return error;
    }
    this.alert('Formato actualizado con éxito');
    this.getFile();
    this.uploadingFile = false;
  }

  async generateDocument() {
    this.documents.profiles = `${environment.baseEndpoint}/filesGeneratorv2/implementation/five/profiles/${this.stationId}`;
    this.documents.designacion = `${environment.baseEndpoint}/filesGeneratorv2/implementation/five/designation/${this.stationId}`;
    this.documents.rh = `${environment.baseEndpoint}/filesGeneratorv2/implementation/five/rh/${this.stationId}`;
    this.documents.structure = `${environment.baseEndpoint}/filesGeneratorv2/implementation/five/structure/${this.stationId}`;
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
